import {HStack, Text} from "@chakra-ui/react";
import {PaginationInputComponent} from "../PaginationInputComponent/PaginationInputComponent";
import * as React from "react";

export interface SectionHeaderProps {
    title: string;
    setPage?: (page: number) => void;
    page?: number;
    totPage?: number;
    rightSection?: React.ReactElement;
}

export const SectionHeader = ({title, setPage, rightSection, page, totPage}: SectionHeaderProps) => {
    return (
        <HStack w={"100%"}>
            <Text fontSize={"24px"} fontWeight={"bold"} ms={"24px"}>{title}</Text>

            {(setPage && page) && <PaginationInputComponent setPage={setPage} page={page}
                                                            totPage={totPage}/>}

            <HStack flex={1} justifyContent={'flex-end'}>
                {rightSection && (rightSection)}
            </HStack>
        </HStack>
    );
}
